import { AssessmentScore } from '../types';

export const scoreMap = {
  [AssessmentScore.VeryGood]: {
    message: 'Very Good',
    status: 'success',
  },
  [AssessmentScore.Good]: {
    message: 'Good',
    status: 'success',
  },
  [AssessmentScore.Acceptable]: {
    message: 'Acceptable',
    status: 'warn',
  },
  [AssessmentScore.Fair]: {
    message: 'Fair',
    status: 'warn',
  },
  [AssessmentScore.Marginal]: {
    message: 'Marginal',
    status: 'error',
  },
  [AssessmentScore.Poor]: {
    message: 'Poor',
    status: 'error',
  },
  [AssessmentScore.NotAvailable]: {
    message: 'No Status',
    status: 'no-status',
  },
};
